"use strict";

exports.__esModule = true;
exports.background = void 0;

var _core = require("../core");

var config = {
  background: {
    property: 'background',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  backgroundImage: {
    property: 'backgroundImage',
    scale: 'colors'
  },
  backgroundClip: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true
};
config.bg = config.background;
config.bgColor = config.backgroundColor;
config.bgImage = config.backgroundImage;
config.bgClip = config.backgroundClip;
config.bgSize = config.backgroundSize;
config.bgPosition = config.backgroundPosition;
config.bgRepeat = config.backgroundRepeat;
config.bgAttachment = config.backgroundAttachment;
var background = (0, _core.system)(config);
exports.background = background;